import { makeAutoObservable, reaction } from 'sdk';

import { ScrollStore } from './scrollStore';

const TIMEOUT = 2 * 1000;

export class DateDelimiterStore {
	constructor(private scrollStore: ScrollStore) {
		makeAutoObservable(this);
		reaction(
			() => this.targetIndex,
			(idx) => {
				this.currentText =
					this.dateDelimiterlist[idx].textContent || this.dateDelimiterlist[0].textContent || '';
			}
		);
		reaction(
			() => this.dateDelimiterlist.length,
			() => {
				this.currentText =
					this.dateDelimiterlist[this.targetIndex].textContent || this.dateDelimiterlist[0].textContent || '';
			}
		);
	}

	stickyDelimiterRef?: HTMLDivElement;
	changeLine = 0;
	targetIndex = 0;
	lastScrollTop = 0;
	isVisibleDelimiter = false;
	currentText = '';
	dateDelimiterlist: HTMLDivElement[] = [];
	stickyDelimiterTop = 0;
	staticDelimiterPaddingTop = 0;
	timeout = 0;

	clearTimeout(): void {
		window.clearTimeout(this.timeout);
		this.timeout = 0;
	}

	setStickyDelimiterRef = (el: HTMLDivElement): void => {
		this.stickyDelimiterRef = el;
	};

	setTargetIndex = (v: number): void => {
		this.targetIndex = v;
	};

	setIsVisibleDelimiter = (v: boolean): void => {
		this.isVisibleDelimiter = v;
	};

	setStickyDelimiterTop = (v: number): void => {
		this.stickyDelimiterTop = v;
	};
	setStaticDelimiterPaddingTop = (v: number): void => {
		this.staticDelimiterPaddingTop = v;
	};

	onScroll = (): void => {
		this.detectTarget();
		this.onVisible();
	};

	/**
	 * Основная функция, устанавливает какой разделитель должен показываться
	 */
	detectTarget = (): void => {
		if (this.scrollStore.scrollWrapper && this.scrollStore.listWrapper) {
			if (this.scrollStore.scrollWrapper && this.stickyDelimiterRef) {
				const stickyDelimiterHeight = this.stickyDelimiterRef.getBoundingClientRect().height;
				this.changeLine =
					this.scrollStore.scrollWrapper.getBoundingClientRect().top +
					this.stickyDelimiterTop +
					stickyDelimiterHeight -
					this.staticDelimiterPaddingTop;
			}
			if (this.dateDelimiterlist.length !== 1) {
				const downIdx = this.getClosestDown();
				this.setTargetIndex(downIdx);
			}
		}
	};

	/**
	 * Ищет наименьшее ближайшее число к "линии изменения"
	 * @returns наименьшее ближайшее
	 */
	getClosestDown = (): number => {
		let closestDown = -Infinity;
		let downIdx = 0;
		this.dateDelimiterlist.forEach((v, idx) => {
			const top = v.getBoundingClientRect().top;
			if (top < this.changeLine) {
				if (top > closestDown) {
					closestDown = top;
					downIdx = idx;
				}
			}
		});
		return downIdx;
	};

	/**
	 * Устанавливаем видимость разделителя
	 */
	onVisible = (): void => {
		if (this.scrollStore.isTop) {
			this.setIsVisibleDelimiter(false);
		} else if (!this.isVisibleDelimiter) {
			this.setIsVisibleDelimiter(true);
			if (!this.timeout)
				this.timeout = window.setTimeout(() => {
					this.setIsVisibleDelimiter(false);
					this.clearTimeout();
				}, TIMEOUT);
		}
	};

	/*
    /Добавляет разделитель при скроле вверх 
    */
	addDateDelimiter = (el: HTMLDivElement): void => {
		if (this.dateDelimiterlist.length === 0) {
			this.dateDelimiterlist.push(el);
		} else {
			const index = this.dateDelimiterlist.findIndex(
				(v) => v.innerText.toLowerCase() === el.innerText.toLowerCase()
			);
			if (index >= 0) {
				this.dateDelimiterlist[index] = el;
			} else {
				this.dateDelimiterlist.push(el);
			}
		}
	};
}
